var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.users)?_c('div',{staticClass:"grid-x grid-margin-x"},[_c('div',{staticClass:"cell auto"},[_c('data-table',{attrs:{"icon":"icon-menu-profile","title":_vm.$t('metrics.user_performance'),"headers":_vm.user_performance_headers,"items":_vm.users}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }